// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Set from "../Data.Set/index.js";
var keys = /* #__PURE__ */ (function () {
    var $0 = Data_Functor["void"](Data_Map_Internal.functorMap);
    return function ($1) {
        return Data_Set.fromMap($0($1));
    };
})();
export {
    keys
};
export {
    alter,
    catMaybes,
    checkValid,
    delete,
    difference,
    empty,
    filter,
    filterKeys,
    filterWithKey,
    findMax,
    findMin,
    foldSubmap,
    fromFoldable,
    fromFoldableWith,
    fromFoldableWithIndex,
    insert,
    insertWith,
    intersection,
    intersectionWith,
    isEmpty,
    isSubmap,
    lookup,
    lookupGE,
    lookupGT,
    lookupLE,
    lookupLT,
    mapMaybe,
    mapMaybeWithKey,
    member,
    pop,
    showTree,
    singleton,
    size,
    submap,
    toUnfoldable,
    toUnfoldableUnordered,
    union,
    unionWith,
    unions,
    update,
    values
} from "../Data.Map.Internal/index.js";
//# sourceMappingURL=index.js.map
